(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["popular-pours-collection"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.tse-tabs').forEach((tabContainer) => {
  const buttons = tabContainer.querySelectorAll('button');

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      buttons.forEach((btn) => btn.classList.remove('active'));
      button.classList.add('active');

      const tabContent = button.dataset.tab;
      const productContainer = tabContainer.closest('.popular-pours-collection_wapper');

      if (productContainer) {
        productContainer.querySelectorAll('.tse-products').forEach((products) => {
          products.style.display = products.dataset.tab === tabContent ? 'flex' : 'none';
        });

        productContainer.querySelectorAll('.view_all_btn').forEach((btn) => {
          btn.style.display = btn.dataset.tab === tabContent ? 'block' : 'none';
        });
      }
    });
  });
});
$(document).on('click',".tse-tabs button",function(){
  $('.slide_grid_mobile').slick('refresh');

})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tse-exclusives"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.tse-tabs').forEach((tabContainer) => {
  const buttons = tabContainer.querySelectorAll('button');

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      buttons.forEach((btn) => btn.classList.remove('active'));
      button.classList.add('active');
      const tabContent = button.dataset.tab;
      const parentSection = tabContainer.closest('.tse-section');
      if (!parentSection) return;
      const productContainers = parentSection.querySelectorAll('.tse-products');
      productContainers.forEach((products) => {
        if (products.dataset.tab === tabContent) {
          products.style.display = 'flex';
        } else {
          products.style.display = 'none';
        }
      });
    });
  });
});
$(document).on('click',".tse-tabs button",function(){
  $('.slide_grid_mobile').slick('refresh');

})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-with-content"] && !Shopify.designMode) return;
  try {
    
/* Add custom JS if needed */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whiskies-of-scotland"] && !Shopify.designMode) return;
  try {
    
   const bottleArray = [
        {
            "bottle1": {
                name: "Glen moray",
                colourName: "Pale Gold",
                colourCode: "#E6BE8A",
                nose: " Honeydew melon, summer fruits, icing sugar, jellybeans, soft spice.",
                palate: " Strawberry ice cream, honey, vanilla, zesty.",
                finish: "Summer fruits continue with a hint of juicy oranges, delicate spice and a touch of oak.",
                price: "£44.98",
                vatPrice: "£37.49",
                image: "https://cdn.shopify.com/s/files/1/2486/9908/files/glenmoray-2007.png?v=1688744272",
                logo: "https://cdn.shopify.com/s/files/1/2486/9908/files/logo_1.png?v=1688452998",
                buyLink: "https://thespiritsembassy.com/cart/40081523441699:1",
                AddToCartLink: "https://thespiritsembassy.com/cart/add?id=40081523441699&quantity=1"
            }
        },
        {
            "bottle2": {
                name: "Glenrothes",
                colourName: "Deep Cooper",
                colourCode: "#A34827",
                nose: " Lemon citrus, pear drops, oat biscuits and vanilla.",
                palate: " Tropical fruits, golden syrup, white pepper, toasted oak.",
                finish: "Apple crumble, vanilla cream, with a warming spice.",
                price: "£37.99",
                vatPrice: "£31.66",
                image: "https://cdn.shopify.com/s/files/1/2486/9908/files/glenrothes-2013.png?v=1688744272",
                logo: "https://cdn.shopify.com/s/files/1/2486/9908/files/logo_4.png?v=1688452997",
                buyLink: "https://thespiritsembassy.com/cart/40081521672227:1",
                AddToCartLink: "https://thespiritsembassy.com/cart/add?id=40081521672227&quantity=1"
            }
        },
        {
            "bottle3": {
                name: "Bunnahabhain",
                colourName: "Chestnut Olorosso Sherry",
                colourCode: "#954535",
                nose: " Dried fruits, creamy yogurt and toffee covered plums.",
                palate: " Smooth caramel, dried fruits, cinnamon, cloves, subtle dry sherry notes.",
                finish: "Good length, residual spices, vanilla creaminess.",
                price: "£74.98",
                vatPrice: "£62.49",
                image: "https://cdn.shopify.com/s/files/1/2486/9908/files/Bunnahabhain-2002.png?v=1688744272",
                logo: "https://cdn.shopify.com/s/files/1/2486/9908/files/Bunnahabhain.png?v=1688742706",
                buyLink: "https://thespiritsembassy.com/cart/40081300717603:1",
                AddToCartLink: "https://thespiritsembassy.com/cart/add?id=40081300717603&quantity=1"
            }
        },
        {
            "bottle4": {
                name: "Strathclyde",
                colourName: "Russet Muscat",
                colourCode: "#80461B",
                nose: " Dried fruits, creamy yogurt and toffee covered plums.",
                palate: " Smooth caramel, dried fruits, cinnamon, cloves, subtle dry sherry notes.",
                finish: "Good length, residual spices, vanilla creaminess.",
                price: "£77.99",
                vatPrice: "£64.98",
                image: "https://cdn.shopify.com/s/files/1/2486/9908/files/Strathclyde-1990.png?v=1688744272",
                logo: "https://cdn.shopify.com/s/files/1/2486/9908/files/strathclyde-new.png?v=1688742740",
                buyLink: "https://thespiritsembassy.com/cart/40081525964835:1",
                AddToCartLink: "https://thespiritsembassy.com/cart/add?id=40081525964835&quantity=1" 
            }
        },
        {
            "bottle5": {
                name: "Miltonduff",
                colourName: "Tawny",
                colourCode: "#CD5700",
                nose: " Fruit cake and cinnamon with a hint of pepper and stewed red apples.",
                palate: " Vanilla and toasted oak along with blackcurrants and honey.",
                finish: "Complex and fruity with more pepper and dried winter berries.",
                price: "£44.98",
                vatPrice: "£37.49",
                image: "https://cdn.shopify.com/s/files/1/2486/9908/files/Miltonduff-2009.png?v=1688744271",
                logo: "https://cdn.shopify.com/s/files/1/2486/9908/files/miltonduff-new.png?v=1688742740",
                buyLink: "https://thespiritsembassy.com/cart/40081472782371:1",
                AddToCartLink: "https://thespiritsembassy.com/cart/add?id=40081472782371&quantity=1"
            }
        },
        {
            "bottle6": {
                name: "Glentauchers",
                colourName: "Auburn",
                colourCode: "#A52A2A",
                nose: " Dried banana chips, strawberry laces, leather, a touch of pepper.",
                palate: " Maple syrup, raspberry jam, custard creams, with a lovely warming spice.",
                finish: "Chocolate orange, cinnamon, sherry sweetness, juicy, mouthcoating.",
                price: "£44.98",
                vatPrice: "£37.49",
                image: "https://cdn.shopify.com/s/files/1/2486/9908/files/glentauchers-2008.png?v=1688744272",
                logo: "https://cdn.shopify.com/s/files/1/2486/9908/files/logo_3.png?v=1688452997",
                buyLink: "https://thespiritsembassy.com/cart/40081519575075:1",
                AddToCartLink: "https://thespiritsembassy.com/cart/add?id=40081519575075&quantity=1"
            }
        },
    ];

    const colourArray = ["#E6BE8A", "#A34827", "#954535", "#80461B", "#CD5700", "#A52A2A"];

    function setSelectedKey(e) {
        let selectedBottle = "bottle1";
        let slideIndex = 0;

        if (e && e.target && e.target.id) {
            selectedBottle = e.target.id
        }
        function generateNameList(arr) {
            let items = "";
            arr.map((item, index) => {
                let key = Object.keys(item)[0];
                let selectedKeyIndex = arr.findIndex(item => Object.keys(item)[0] === selectedBottle)
                items += `<h2 class="${index <= selectedKeyIndex && "active"}">${item[key].name}</h2>`
            });

            return items;
        }

        function generateSlider(arr) {
            let sliderItems = "";
            arr.map((item, index) => {
                let key = Object.keys(item)[0];
                sliderItems += ` <div id="bottle${index + 1}" class="bottle_inner_section ${key == selectedBottle && "active"}">
                        <div class="logo_section" id="bottle${index + 1}">
                            <img src="${item[key].logo}" alt="logo" width="39" height="39" id="bottle${index + 1}"/>
                        </div>
                        <img src="${item[key].image}" alt="bottle img" width="99" height="424"  id="bottle${index + 1}"/>
                    </div>`
            });

            return sliderItems;
        }

        function getColourShow(arr, selectedObject) {
            let colourItems = "";

            arr.map((item, index) => {
                let key = Object.keys(selectedObject)[0];
                colourItems += ` <span class="${item == selectedObject[key].colourCode && "active"}" style="background:${item};"></span>`
            });
            return colourItems;
        }

        function generateNotes(arr) {
            let noteItems = "";

            let selectedObject = arr.find((item, index) => Object.keys(item)[0] === selectedBottle);

            noteItems = `<div class="tasting_notes">
                    <label>tasting notes</label>
                    <h6><b>COLOUR</b>: ${selectedObject[selectedBottle].colourName}</h6>
                    <div class="colour_section">
                        ${getColourShow(colourArray, selectedObject)}
                    </div>
                    <h6><b>NOSE</b>:  ${selectedObject[selectedBottle].nose}</h6>
                    <h6><b>PALATE</b>: ${selectedObject[selectedBottle].palate}</h6>
                    <h6><b>FINISH</b>: ${selectedObject[selectedBottle].finish}</h6>
                    <div class="price_section">
                        <h5><b>PRICE</b>:  ${selectedObject[selectedBottle].price}</h5>
                        <h5> EX VAT PRICE: ${selectedObject[selectedBottle].vatPrice}</h5>
                    </div>
                    <div class="buy_btn_section">
                        <a class="btn_buy" href="${selectedObject[selectedBottle].buyLink}" target="_blank">
                            buy now
                        </a>
                        <a class="btn_add_cart" href="${selectedObject[selectedBottle].AddToCartLink}" target="_blank">
                            ADD TO CART
                        </a>
                    </div>`

            return noteItems
        }


        function generateMobileSlide(arr) {
            let mobileNoteItems = "";

            arr.map((item, index) => {
                let key = Object.keys(item)[0];
                mobileNoteItems += ` <div class="slide">
                   <div class="mobile_bottle_details">
                       <div class="mobile_slide_section">
                           <div class="mobile_bottle_section">
                               <div class="bottle_inner_section">
                                   <div class="logo_section">
                                       <img src="${item[key].logo}" alt="logo" width="69" height="57" />
                                   </div>
                                   <img src="${item[key].image}" alt="bottle img" width="41" height="178" />
                               </div>
                           </div>
                           <div class="mobile_tasting_section">
                               <label>tasting notes</label>
                               <h6><b>COLOUR</b>: ${item[key].colourName}</h6>
                               <div class="colour_section">
                                   ${getColourShow(colourArray, item)}
                               </div>
                               <h6><b>NOSE</b>: ${item[key].colourName}</h6>
                               <h6><b>PALATE</b>: ${item[key].palate}</h6>
                               <h6><b>FINISH</b>: ${item[key].finish}</h6>
                               <div class="price_section">
                                   <h5><b>PRICE</b>: ${item[key].price}</h5>
                                   <h5> EX VAT PRICE: ${item[key].vatPrice}</h5>
                               </div>
                           </div>
                       </div>
                       <div class="buy_btn_section">
                           <a class="btn_buy" href="${item[key].buyLink}" target="_blank">
                               buy now
                           </a>
                           <a class="btn_add_cart" href="${item[key].AddToCartLink}" target="_blank">
                               ADD TO CART
                           </a>
                       </div>
                   </div>
               </div>`
            });

            return mobileNoteItems
        }

        function generateMobileSlideDts(arr) {
            let sliderDtsItems = "";

            arr.map((item, index) => {
                sliderDtsItems += `<span class="dot ${index === slideIndex && "active"} dot-class-${index}" id="${index}"></span>`
            });

            return sliderDtsItems;
        }

        document.querySelector(".whisky_title_section").innerHTML = `${generateNameList(bottleArray)}`
        document.querySelector(".bottle_slider_slides").innerHTML = `${generateSlider(bottleArray)}`
        document.querySelector(".right_inner_section").innerHTML = `${generateNotes(bottleArray)}`
        document.querySelector(".mobile-slider").innerHTML = `${generateMobileSlide(bottleArray)}`
        document.querySelector(".dot-container").innerHTML = `${generateMobileSlideDts(bottleArray)}`
        const slider = document.querySelector('.mobile-slider');
        const prevBtn = document.querySelector('.prev-btn');
        const nextBtn = document.querySelector('.next-btn');
        const dots = document.querySelectorAll('.dot-container');
        const dotSelect = document.querySelectorAll(".dot");
        const bottleSelect = document.querySelectorAll(".bottle_inner_section");

        prevBtn.addEventListener('click', () => {
            slideIndex = (slideIndex - 1 + slider.children.length) % slider.children.length;
            for (let dotId of dotSelect) {
                dotId.classList.remove("active")
            }
            let className = (`.dot-class-${slideIndex}`).toString("");
            let selectedSliderDotChange = document.querySelector(className);
            if (selectedSliderDotChange) {
                selectedSliderDotChange.classList.add("active")
            }
            updateSlidePosition();
        });

        nextBtn.addEventListener('click', () => {
            slideIndex = (slideIndex + 1) % slider.children.length;
            for (let dotId of dotSelect) {
                dotId.classList.remove("active")
            }
            let className = (`.dot-class-${slideIndex}`).toString("");
            let selectedSliderDotChange = document.querySelector(className);
            if (selectedSliderDotChange) {
                selectedSliderDotChange.classList.add("active")
            }
            updateSlidePosition();
        });

        function updateSlidePosition() {
            slider.style.transform = `translateX(-${slideIndex * 100}%)`;
        }

        function setSelectedDot(e) {
            slideIndex = e.target.id
            for (let dotId of dotSelect) {
                dotId.classList.remove("active")
            }
            var clickedDot = e.target;
            clickedDot.classList.add("active");
            updateSlidePosition();
        }

        for (let dotId of dotSelect) {
            dotId.addEventListener("click", setSelectedDot);
        }

        for (let bottleId of bottleSelect) {
            bottleId.addEventListener("click", setSelectedKey);
        }
    }

    setSelectedKey()

  } catch(e) { console.error(e); }
})();
})();
